export default __webpack_public_path__ + "static/media/Vector (5).2226b3df.svg";